export const StatusArrayObject = [
  'COMPLETED',
  'CANCELED',
  'WAIT_ADJUST',
  'PENDING',
  'ADJUSTED',
];

export const PaymentMethods: { [key: string]: string } = {
  payment_link: 'Link',
  store_credit: 'Saldo',
  physical_card: 'POS',
  pix: 'PIX',
};

export const PAYMENTS_TYPES = {
  manual_physical_card: 'manual_physical_card',
  pix: 'pix',
  physical_card: 'physical_card',
  payment_link: 'payment_link',
  store_credit: 'store_credit',
};
